@import '~style-sheet-helpers/core.less';

.delete-modal {
  height: 355px;
  width: 780px;
}

.modal-body {
  display: flex;
  flex-direction: column;
  height: 100%;

  .disclaimer-text {
    font-size: 14px;
    padding: 12px 16px;
    line-height: 24px;
  }
}

.modal-body.iframe-mode {
  div:last-child,
  iframe {
    border: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
}

.success-notification {
  line-height: 24px;
}
